import { IApplicationState } from '../../types/redux';

export const getNewbuildingFlightEntryUrl = (state: IApplicationState) => {
  return state.config.newbuildingFlightEntryUrl;
};
